// URL Parameters and Tracking Codes
export const BRAND_BASE_URL = "https://roundhouseprovisions.com";
export const CDN_BASE_URL = "https://cdn.roundhouseprovisions.com";
export const CART_BASE_URL = "https://cart.roundhouseprovisions.com";
export const BRIGHTCOVE_BASE_URL = "https://players.brightcove.net/6058022021001";
export const LEGAL_BASE_URL = "https://legal.roundhouseprovisions.com";

// CDN Image URLs
export const CDN_IMAGES = {
  BRAND_LOGO: `${CDN_BASE_URL}/images/rh_logo.png`,
  BRAND_LOGO_WHITE: `${CDN_BASE_URL}/images/rh_logo-white.png`,
  LOGO_SHORT: `${CDN_BASE_URL}/images/RoundhouseProvisions-Logo_short.png`,
  PALM_WAIT: `${CDN_BASE_URL}/images/rh_hand.png`,
  UP_YES: `${CDN_BASE_URL}/images/upYes.jpg`,
  UP_NO: `${CDN_BASE_URL}/images/upNo.jpg`,
  UP_YES_MOBILE: `${CDN_BASE_URL}/images/upYes_mobile.jpg`,
  UP_NO_MOBILE: `${CDN_BASE_URL}/images/upNo_mobile.jpg`,
  GRAY_CHECK: `${CDN_BASE_URL}/images/gray_check2.png`,
  BLUE_CHECK: `${CDN_BASE_URL}/images/blue_check.png`,
  HEALTH_IMAGE: `${CDN_BASE_URL}/images/5c1e24a802aa7adbf71d89a06ddb417581fa46ea.jpg`,
  FIELD_DESKTOP: `${CDN_BASE_URL}/images/Field_Desktop.png`,
  SPINNING_WHEEL_CIRCLES: `${CDN_BASE_URL}/images/spinning-wheel-small_circlesfull.png`,
  SPINNING_WHEEL_TRIANGLE: `${CDN_BASE_URL}/images/spinning-wheel-triangle.png`,
  PHONE: `${CDN_BASE_URL}/images/phone.png`,
  GUNDRY_BODY: `${CDN_BASE_URL}/images/gundry-body.png`,
  CHUCK_WITHHORSE_MOBILE: `${CDN_BASE_URL}/images/chuck_WithHorse-Mobile-comp.png`,
  CHUCK_WITHHORSE_DESKTOP: `${CDN_BASE_URL}/images/chuck_WithHorse-Desktop-comp.png`,
  LOGO_CIRCLE: `${CDN_BASE_URL}/images/logo-circle.png`,
  BIOC_COMPLETE3_SUPP: `${CDN_BASE_URL}/images/bio-complete-3/BioComplete3-supp.png`,
  STAR_GREEN: `${CDN_BASE_URL}/1starGreen.png`,
  MYACCOUNT_CHECKMARK: `${CDN_BASE_URL}/images/Myaccount-checkmark-sign-up.png`,
  BRAND_LOGO_3X: `${CDN_BASE_URL}/images/RoundhouseProvisions-Logo@3x.png`,
  PHONE2: `${CDN_BASE_URL}/images/phone2.png`,
  CHECKOUT_90DAY: `${CDN_BASE_URL}/images/90day_guarantee_comp.png`,
  TROPHY: `${CDN_BASE_URL}/images/trophy.svg`,
  CHECKOUT_TRUCK: `${CDN_BASE_URL}/images/checkout_truck.svg`,
  SUBSCRIPTION_TERMS: `${CDN_BASE_URL}/continuitiy/roundhouse-terms.html`
};

export const LINK_PAGES = {
  CA_PRIVACY_NOTICE: `${LEGAL_BASE_URL}/privacy-policy#Additional-Information-for-California-Residents`,
  PRIVACY_POLICY: `${LEGAL_BASE_URL}/privacy-policy/`,
  REGISTER: `${CART_BASE_URL}/register/`,
  TERMS_AND_CONDITIONS: `${LEGAL_BASE_URL}/terms/`,
};

export const PARAM = "n";
export const OBTCR = "obtcr";
export const TBATCR = "tbatcr";
export const FBTCR = "fbtcr";
export const DBTCR = "dbtcr";
export const REVTCR = "revtcr";
export const ADV = "Advertorial";
export const ADVERT = "Advertisement";
export const OPT = 'opt';
export const OBNATCR = 'obnatcr';
export const MSNTCR = 'msntcr';
export const OB = 'ob';
export const AOL = 'aol';
export const AOLTCR = 'aoltcr';
export const GDN = 'gdn';
export const GDNTCR = 'gdntcr';
export const AYAHTCR = 'ayahtcr';
export const AYAHC = 'ayahc';
export const AYAHLG = 'ayahlg';
export const ATBATCR = 'atbatcr';
export const VMXGUN = 'vmxgun';
export const RMGEM = 'rm-gem';
